// api.js
const imgUrl = 'https://bulkaceramics.com';


export default imgUrl;
